import React, { useState } from 'react';
import './fleet.css';
import AnagraficaMezzi from './AnagraficaMezzi';
import SpeseOperative from './SpeseOperative';
import ScadenzeFleet from './ScadenzeFleet';
import ManutenzioneFleet from './ManutenzioneFleet';
import MulteFleet from './MulteFleet';
import CarteFleet from './CarteFleet';
import IngressiUscite from './IngressiUscite';
import DashboardFleet from './DashboardFleet';

const TABS = [
  { key: 'dashboard',    label: 'Dashboard' },
  { key: 'mezzi',        label: 'Veicoli' },
  { key: 'spese',        label: 'Spese' },
  { key: 'scadenze',     label: 'Scadenze' },
  { key: 'manutenzione', label: 'Manutenzione' },
  { key: 'multe',        label: 'Multe' },
  { key: 'carte',        label: 'Carte & Telepass' },
  { key: 'ingressi',     label: 'Ingressi/Uscite' },
];

export default function FleetPage() {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <div className="fleet-page">
      <div className="page-header">
        <h1>Gestione Parco Auto</h1>
      </div>

      <div className="fleet-tabs">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`fleet-tab-btn${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="fleet-tab-content">
        {activeTab === 'dashboard'    && <DashboardFleet />}
        {activeTab === 'mezzi'        && <AnagraficaMezzi />}
        {activeTab === 'spese'        && <SpeseOperative />}
        {activeTab === 'scadenze'     && <ScadenzeFleet />}
        {activeTab === 'manutenzione' && <ManutenzioneFleet />}
        {activeTab === 'multe'        && <MulteFleet />}
        {activeTab === 'carte'        && <CarteFleet />}
        {activeTab === 'ingressi'     && <IngressiUscite />}
      </div>
    </div>
  );
}
